import request from '@/utils/request'


// 查询天气图标信息列表
export function listImage(query) {
  return request({
    url: '/weather/image/list',
    method: 'get',
    params: query
  })
}

// 查询天气图标信息分页
export function pageImage(query) {
  return request({
    url: '/weather/image/page',
    method: 'get',
    params: query
  })
}

// 查询天气图标信息详细
export function getImage(data) {
  return request({
    url: '/weather/image/detail',
    method: 'get',
    params: data
  })
}

// 新增天气图标信息
export function addImage(data) {
  return request({
    url: '/weather/image/add',
    method: 'post',
    data: data
  })
}

// 修改天气图标信息
export function updateImage(data) {
  return request({
    url: '/weather/image/edit',
    method: 'post',
    data: data
  })
}

// 删除天气图标信息
export function delImage(data) {
  return request({
    url: '/weather/image/delete',
    method: 'post',
    data: data
  })
}
